import { render, staticRenderFns } from "./CustomerSelection.vue?vue&type=template&id=74143416&"
import script from "./CustomerSelection.vue?vue&type=script&lang=js&"
export * from "./CustomerSelection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSelection.vue?vue&type=style&index=0&id=74143416&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports